module.exports = __webpack_public_path__ + "ms.svg?87080c15ab589b7798f0e747a8e1469d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ms.svg
// module id = 885
// module chunks = 27